/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { memo, useState } from "react";
import { Badge } from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import Avatar from '@mui/material/Avatar';

import { theme } from "../../../theme";
import Header from "./header";
import { data } from "../data";
import { getUserInfo } from "../../../storage";
import { truncateText } from "../../../utils";
import { logoutCustomer } from "../../service";

const NavItemBox = ({ icon, name }) => {
    return (
        <>
            <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                <i className="material-symbols-rounded opacity-5">{icon}</i>
            </div>
            <span className="nav-link-text ms-1">{name}</span>
        </>
    );
}

const SectionHeader = memo(({ title }) => {
    if (!title) return null;
    return (
        <li className="nav-item mt-3">
            <h6 className="ps-4 ms-2 text-uppercase text-xs text-white font-weight-bolder opacity-8">
                {title}
            </h6>
        </li>
    );
});

const NavItem = memo(({ listItem, ftmCount, jobCount }) => {
    const { name, to, icon } = listItem;
    const isApplicationsOrJobs = name === "Applications" || name === "Cancel Jobs";
    const badgeContent = name === "Applications" ? ftmCount : jobCount;

    return (
        <li className="nav-item">
            <NavLink
                className={({ isActive }) =>
                    isActive
                        ? `nav-link text-white active bg-gradient-${theme.main}`
                        : "nav-link text-white"
                }
                to={to}
            >
                {isApplicationsOrJobs ? (
                    <Badge badgeContent={badgeContent} color={theme.sidebar_notification_count_color}>
                        <NavItemBox icon={icon} name={name} />
                    </Badge>
                ) : <NavItemBox icon={icon} name={name} />}
            </NavLink>
        </li>
    );
});

const Profile = () => {
    const navigate = useNavigate();

    const userInfo = getUserInfo();
    const shotName = truncateText(userInfo?.customer_name, 20);

    const [showDropdown, setShowDropdown] = useState(false);

    const links = [
        {
            name: "My profile",
            to: "/profile",
            icon: "person"
        },
        {
            name: "Credit notes",
            to: "/credit/note/list",
            icon: "account_balance_wallet"
        },
        {
            name: "Logout",
            to: "#",
            icon: "logout"
        }
    ];

    return (
        <>
            <li className="nav-item mb-2 mt-0">
                <a  
                    href="#ProfileNav" 
                    className="nav-link text-white d-flex align-items-center justify-content-between" 
                    aria-controls="ProfileNav" 
                    role="button" 
                    aria-expanded="false" 
                    onClick={() => setShowDropdown(!showDropdown)}
                >
                    {userInfo?.customer_profile_image ? (
                        <img src={userInfo?.customer_profile_image} className="avatar" alt="customer_profile_image" />
                    ) : (
                        <Avatar sx={{ width: 30, height: 30, fontSize: '12px' }}>
                            {userInfo?.customer_name?.toUpperCase()?.charAt(0)}
                        </Avatar>
                    )}
                    <span className="nav-link-text ms-2 ps-1">{shotName}</span>
                    <i className="material-symbols-rounded opacity-5">keyboard_arrow_{showDropdown ? 'down' : 'up'}</i>
                </a>
                <div className="collapse" id="ProfileNav" style={{display: showDropdown ? "block" : "none"}}>
                    <ul className="nav ">
                        {links.map((link, index) => (
                            <li className="nav-item" key={index}>
                                <NavLink 
                                    className="nav-link text-white" 
                                    to={link.to} 
                                    onClick={link.to !== "#" ? () => setShowDropdown(false) : () => logoutCustomer(navigate)}
                                >
                                    <i className="material-symbols-rounded opacity-5">{link.icon}</i>
                                    <span className="sidenav-normal ms-3 ps-1"> {link.name} </span>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </div>
            </li>

            <hr className="horizontal white mt-0" />
        </>
    );
};

const FullSidebar = ({ ftmCount, jobCount, isFullSidebar }) => {
    return (
        <aside
            className="sidenav navbar navbar-vertical navbar-expand-xs border-radius-lg fixed-start ms-2  bg-gradient-dark my-2"
            // className="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3 bg-gradient-dark"
            id="sidenav-main"
            style={{ overflowX: "hidden" }}
        >
            <Header isFullSidebar={isFullSidebar} />
            <hr className="horizontal light mt-0 mb-2" />
            <div className="collapse navbar-collapse w-auto" id="sidenav-collapse-main" style={{ overflowX: "hidden" }}>
                <ul className="navbar-nav">
                    <Profile />
                    {data.map((item, index) => (
                        <React.Fragment key={index}>
                            <SectionHeader title={item.heder} />
                            {item.list.map((listItem, idx) => (
                                <NavItem
                                    key={idx}
                                    listItem={listItem}
                                    ftmCount={ftmCount}
                                    jobCount={jobCount}
                                />
                            ))}
                        </React.Fragment>
                    ))}
                </ul>
            </div>
        </aside>
    );
};

export default FullSidebar;